(function(){
    "use strict";
    
    angular
        .module("app")
        .component("saml", { // impersonate
            templateUrl: "src/app/saml/saml.html",
            controller: controller
        });

    function controller($routeParams, $cookies, $location, session, loginModal) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            const token = $routeParams.token;
            $cookies.put("stcart", token);
            session.refresh(true).then(() => {

                session.isLoaded = true; // Set this here because overriding the app.run function.

                if (!session.customer)
                    loginModal("chooseCustomer").then(() => $location.path("/"));
                else
                    $location.path("/");

            });
        };
    }
    controller.$inject = ["$routeParams", "$cookies", "$location", "sessionService", "loginModal"];
    
})()